import Image from 'next/image'

import { ScreenSize } from '@/app/constants/index'
import { useCurrentBreakpoint } from '@/app/hooks/useCurrentBreakpoint'
import { useServiceErrorsStore } from '@/components/entities/common/model/service-errors.store'
import { formatPhoneNumber } from '@/utils/number'

export const ServiceUnavailable = () => {
  const { error } = useServiceErrorsStore()
  const { breakpoint } = useCurrentBreakpoint()
  const isMobileScreen = [ScreenSize.Xxs].includes(breakpoint)

  return (
    <div className="m-auto flex max-w-[700px] flex-col items-center justify-center gap-8 text-center md:max-w-[380px] xxs:max-w-[260px]">
      <Image
        src="/images/shared/Exclamation.png"
        width={isMobileScreen ? 80 : 140}
        height={isMobileScreen ? 80 : 140}
        alt="image"
      />
      <p className="font-bold text-28 xxs:text-20">{error?.title}</p>
      <p className="mb-28 text-grey-70 text-20 md:mb-20 xxs:mb-14 xxs:text-14">
        {error?.message}
      </p>
      <p className="text-grey-70 text-20 md:max-w-[280px] xxs:max-w-[200px] xxs:text-14">
        Обратиться в поддержку можно по номеру{' '}
        <a
          className="text-bronze-40 text-20 xxs:text-14"
          href={`tel:${error?.contactPhone}`}
        >
          {formatPhoneNumber(error?.contactPhone)}
        </a>
      </p>
    </div>
  )
}
